import React from 'react';
import '../../../assets/css/style.css';
import RadioChipContainer from '../elements/RadioChipContainer';

const VirtuesPreference = () => {
    const genderNames = ['Male','Female','Both'];
    
    return (
        <div className="chip-container">
            <RadioChipContainer labels={genderNames} type="genderPreference" />
        </div>
    );
};

export default VirtuesPreference;